import { useCallback, useEffect, useState } from 'react';
export function useWebVoiceRequest({ eligible, accountId, }) {
    const [request, setRequest] = useState(null);
    const close = useCallback(() => setRequest(null), []);
    const open = useCallback(() => {
        if (!eligible || !accountId)
            return;
        setRequest((previous) => ({ accountId, focusRequest: (previous?.focusRequest ?? 0) + 1 }));
    }, [accountId, eligible]);
    // Revoked eligibility must discard intent, so restoring it never reopens the microphone.
    useEffect(() => {
        if (!eligible || request?.accountId !== accountId)
            close();
    }, [eligible, accountId, request, close]);
    return { request: eligible && request?.accountId === accountId ? request : null, open, close };
}
//# sourceMappingURL=useWebVoiceRequest.js.map